import './App.css';
import Home from './pages/home/home';
import { BrowserRouter, Route } from 'react-router-dom'
import About from "./pages/about/about";
import Contact from "./pages/contact/contact";
import Terms from "./pages/terms/terms";
import Login from "./pages/login/login";
import Register from "./pages/register/register";
import Forgot from "./pages/forgot/forgot";
import Services from "./pages/services/services";
import ServiceDetail from "./pages/service_detail/servicedetail";
import Preloader from "./components/preloader/preloader";
import './assets/css/style.css';
import './assets/css/responsive.css';
import { useEffect, useState } from 'react';
import ProviderLogin from './pages/login/provider_login';
import ProviderRegister from './pages/register/provider_register';
import Checkout from './pages/checkout/checkout';
import Blogs from './pages/blogs/blogs';
import BlogDetail from './pages/blog_detail/blogdetail';
import Cart from "./pages/cart/cart";

function App() {
  const [showPreloader, setPreloader] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setPreloader(prev => prev = false)
    }, 3000);
  }, [])

  return (
    <>
      {showPreloader && <Preloader />}
      <BrowserRouter>
        <Route exact path="/" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/contact" component={Contact} />
        <Route path="/terms" component={Terms} />
        <Route path="/login" component={Login} />
        <Route path="/provider-login" component={ProviderLogin} />
        <Route path="/provider-register" component={ProviderRegister} />
        <Route path="/register" component={Register} />
        <Route path="/forgot" component={Forgot} />
        <Route path="/services" component={Services} />
        <Route path="/services-detail" component={ServiceDetail} />
        <Route path="/checkout" component={Checkout} />
        <Route path="/blogs" component={Blogs} />
        <Route path="/blog-detail" component={BlogDetail} />
        <Route path="/cart" component={Cart} />
      </BrowserRouter>
    </>
  )
}

export default App;
